import { render } from "./ManageInsuranceOverlay.vue?vue&type=template&id=52738a32&scoped=true&lang=pug"
import script from "./ManageInsuranceOverlay.vue?vue&type=script&lang=js"
export * from "./ManageInsuranceOverlay.vue?vue&type=script&lang=js"

import "./ManageInsuranceOverlay.vue?vue&type=style&index=0&id=52738a32&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52738a32"]])

export default __exports__